import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Avatar, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Collapse } from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { showModal } from "../../redux/dispatchers";
import { logoutUser } from "../../service/logic";
import { history } from "../../index";
import jwtDecode from "jwt-decode";
import { getOptions } from "../../service/api/option";

const useStyles = makeStyles((theme) => ({
  header: {
    position: "sticky",
    top: 0,
    left: 0,
    width: "100%",
    backgroundColor: "#3d6d8b",
    height: 78,
    borderStyle: "solid",
    borderWidth: "0px 0px 0.5px 0px",
    display: "flex",
    flexDirection: "row",
    zIndex: 10,
  },
  left: {
    maxWidth: 250,
    height: 78,
    top: 0,
    position: "absolute",
    left: 3,
  },
  right: {
    height: 78,
    top: 0,
    position: "absolute",
    right: 0,
    marginRight: 35,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    cursor: "pointer",
    [theme.breakpoints.down("sm")]: {
      marginRight: 15,
    },
  },
  details: {
    height: "80px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    color: "white",
    fontWeight: 900,
    maxWidth: 145,
  },
  stage: {
    fontWeight: "200",
    cursor: "context-menu",
  },
  test: {
    color: "white",
  },
  center: {
    width: "99%",
    position: "absolute",
    height: 78,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    letterSpacing: "1px",
  },
  iconImg: {
    maxWidth: 250,
    height: 130,
    top: -23,
    position: "absolute",
  },
  button: {
    zIndex: 15,
  },
  title: {
    cursor: "context-menu",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  collapseContainer: {
    position: "absolute",
    backgroundColor: "white",
    zIndex: 15,
    marginTop: 70,
    right: 40,
    borderRadius: 10,
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
  },
  listItem: {
    marginLeft: 15,
  },
  avatar: {
    marginRight: 15,
    [theme.breakpoints.down("sm")]: {
      marginRight: 10,
    },
  },
  avatarIcon: {
    width: 40,
    height: 40,
    color: "white",
    marginRight: 15,
    [theme.breakpoints.down("sm")]: {
      marginRight: 10,
    },
  },
}));

const GeneralHeader = ({ profile, backArrow, mode, navigate }) => {
  const classes = useStyles();
  const [collapse, setCollapse] = useState(false);
  const { accessToken } = useSelector((state) => state.authDetails);
  const [stage, setStage] = useState("");
  const [name, setName] = useState("");
  const [img, setImg] = useState("");

  const { name: selectedStage } = useSelector(
    (state) => state.gameStates.selectedStage
  );

  useEffect(() => {
    getOptions("stage").then((stageOption) => {
      if (!accessToken) return;
      const { stage, name, profile } = jwtDecode(accessToken);
      setName(name);
      if (!!stageOption) {
        const userStage = stageOption.find((x) => x.id === stage);
        if (!!userStage && !!userStage.name) setStage(userStage.name);
        else setStage(stage);
      } else setStage(stage);
      setImg(profile);
    });
  }, [accessToken]);

  const toggleCollapse = () => {
    setCollapse(!collapse);
  };

  const navigateProfilePage = () => {
    history.push("/profile");
  };

  const navigateLoginPage = () => {
    showModal(
      "Log Out",
      "Are you sure you want to log out now? You will lose your current game states!",
      "Confirm",
      "Cancel",
      logoutUser
    );
  };

  return (
    <React.Fragment>
      <div className={classes.header}>
        <div className={classes.left}>
          {backArrow ? (
            <div>
              <IconButton
                aria-label="back"
                className={classes.button}
                onClick={navigate}
              >
                <ArrowBackIcon
                  style={{
                    color: "white",
                    height: "50px",
                    width: "50px",
                  }}
                />
              </IconButton>
            </div>
          ) : null}
        </div>
        <div className={classes.center}>
          <Typography variant="h1" className={classes.title}>
            {mode ? mode : selectedStage}
          </Typography>
        </div>
        {profile ? (
          <div className={classes.right} onClick={toggleCollapse}>
            {img ? (
              <Avatar className={classes.avatar} src={img} />
            ) : (
              <AccountCircleIcon className={classes.avatarIcon} />
            )}
            <div className={classes.details}>
              <Typography variant="h4">{name}</Typography>
              <Typography variant="h5" className={classes.stage}>
                {stage}
              </Typography>
            </div>
          </div>
        ) : null}
        <Collapse in={collapse} className={classes.collapseContainer}>
          <List style={{ padding: 0 }}>
            <ListItem button>
              <AccountCircleIcon />
              <ListItemText
                onClick={navigateProfilePage}
                className={classes.listItem}
                primary="View Profile"
              />
            </ListItem>
            <ListItem button onClick={navigateLoginPage}>
              <ExitToAppIcon />
              <ListItemText className={classes.listItem} primary="Log Out" />
            </ListItem>
          </List>
        </Collapse>
      </div>
    </React.Fragment>
  );
};

export default GeneralHeader;
